import { ChevronDown } from "lucide-react";

import { LOCALES, type Locale } from "@/constants/i18n";
import { useLocaleStore, useTranslation } from "@/store/locale";

/**
 * A native `<select>` behind a styled shell.
 *
 * On a phone this opens the platform picker, which is both more usable and more
 * accessible than anything a custom listbox would give us here.
 */
/** The flag stands in for the name, as the legacy pill has it. */
const FLAGS: Record<Locale, string> = { en: "\u{1F1FA}\u{1F1F8}", fil: "\u{1F1F5}\u{1F1ED}" };

export function LanguageSelect() {
  const t = useTranslation();
  const locale = useLocaleStore((state) => state.locale);
  const setLocale = useLocaleStore((state) => state.setLocale);

  const current = LOCALES.find((entry) => entry.code === locale) ?? LOCALES[0];

  return (
    <div className="bg-surface-raised border-line relative inline-flex h-10 items-center rounded-full border shadow-[var(--shadow-lift)]">
      <span aria-hidden className="text-body pointer-events-none ml-3 leading-none">
        {FLAGS[current.code]}
      </span>
      <span className="text-fg text-subhead pointer-events-none ml-2 font-medium">
        {current.short}
      </span>
      <ChevronDown
        aria-hidden
        className="text-fg-subtle pointer-events-none mr-3 ml-1 size-3.5"
      />
      <select
        aria-label={t("language.label")}
        value={locale}
        onChange={(event) => setLocale(event.target.value as Locale)}
        className="absolute inset-0 size-full cursor-pointer rounded-full opacity-0"
      >
        {LOCALES.map((entry) => (
          <option key={entry.code} value={entry.code}>
            {entry.label}
          </option>
        ))}
      </select>
    </div>
  );
}
